/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    DEFAULT: 'default',
    DISCOUNT: 'discount',
    CREDIT: 'credit',
    CREDIT_DISCOUNT: 'credit_discount',
    PASS: 'pass',
    BENEFIT_SURCHARGE: 'benefit_surcharge',
    BENEFIT_SURCHARGE_CREDIT: 'benefit_surcharge_credit',
    BENEFIT: 'benefit',
    OTHER: 'other',
    SINGLE_COURSE_SESSION: 'single_course_session',
};
